import React from 'react'

const Footer = () => {
  return (
    <footer className='w-full h-[30px] dark:bg-slate-900 bg-purple-600 flex items-center'>
        <a href="" className='text-white text-[18px] ml-[10px] sm:ml-[30px]'>Developer</a>
    </footer>
  )
}

export default Footer